import { ModalKey } from "containers/Modals/modals";

import { createAction } from "@reduxjs/toolkit";

import * as t from "../constants";

export type ModalMetaInput = {
  [key: string]: unknown;
  id?: string;
  header?: string;
  text?: string;
  callback?(args?: unknown): void;
};

export const closeModal = createAction(t.RESET_MODAL);

export const setModal = createAction(t.SET_MODAL, (modal: ModalKey, data: ModalMetaInput = {}) => ({
  payload: {
    modal,
    data,
  },
}));
